import React from 'react'

function NeedHelp({ title = "Need Help ?", tagline = "Our team is here to help you through the process.", email = 'support@fwpiindia.com', phone_no = '9996108446', isApplyGradient = true, }) {
    return (
        <section className={`w-full${isApplyGradient ? ' bg-gradient-radial' : ''} py-2 lg:py-10 lg:pt-0`}>
            <div className="container mx-auto px-4 lg:px-24">
                <div className='w-full flex flex-col items-center gap-4 md:gap-6 mb-4'>
                    <h2
                        className="text-2xl sm:text-3xl lg:text-5xl font-bold font-urbanist text-white text-center sm:text-center">
                        {title}
                    </h2>
                    <p className="text-sm sm:text-base text-center lg:text-2xl font-urbanist text-stone-300">
                        {tagline}
                    </p>
                    <div className='flex flex-col sm:flex-row items-center gap-3 md:gap-4'>
                        <a href={`mailto:${email}`} className="flex items-center px-0 md:px-2">
                            <img className="md:w-7 md:h-7 w-5 h-5 transition-transform" src="/assets/services/1/mail.jpg" alt="mail" />
                            <span className='px-2 md:px-4 text-white font-urbanist text-sm lg:text-lg group-hover:scale-105 italic'>{email}</span>
                        </a>
                        <a href={`tel:${phone_no}`} className="flex items-center px-0 md:px-2">
                            <img className="md:w-7 md:h-7 w-5 h-5 transition-transform" src="/assets/services/1/phone.png" alt="phone" />
                            <span className='px-2 md:px-4 text-white font-urbanist text-sm lg:text-lg group-hover:scale-105 italic'>+91-{phone_no}</span>
                        </a>

                    </div>
                </div>
            </div>
        </section>
    )
}

export default NeedHelp